import WaitlistedNotification from './WaitlistedNotification';
export default WaitlistedNotification;